import { Table } from 'element-ui'
import { parseHeight } from '@/utils'

const ElTablePatched = {
  extends: Table,
  computed: {
    bodyHeight() {
      const { headerHeight = 0, bodyHeight, footerHeight = 0 } = this.layout
      if (this.height) {
        // 重置height为auto的固定为auto
        if (this.height === 'auto') {
          return {
            height: 'auto'
          }
        } else {
          return {
            height: bodyHeight ? bodyHeight + 'px' : ''
          }
        }
      } else if (this.maxHeight) {
        const maxHeight = parseHeight(this.maxHeight)
        if (typeof maxHeight === 'number') {
          return {
            'max-height': (maxHeight - footerHeight - (this.showHeader ? headerHeight : 0)) + 'px'
          }
        }
      }
      return {}
    },
  }
}


export default {
  install(Vue) {
    Vue.component(Table.name, ElTablePatched)
  }
}
